import { Type, Static } from '@sinclair/typebox';

export const reactionCounterSchema = Type.Array(
  Type.Object({
    reaction: Type.String({ description: 'Value of the reaction. Usually an emoji unicode.' }),
    count: Type.Number({ description: 'The total count of this reaction.' }),
  }),
  { description: 'A list of reactions to the element.' },
);

export type ReactionCounter = Static<typeof reactionCounterSchema>;
